import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ListItem } from '../List.style';
import { ContentH4 } from 'src/domains/layouts/shared/typography/Content.style';

export const EmptyListItem = observer('EmptyListItem', () => {
    return (
        <ListItem direction='row' isEmpty={true}>
            <ContentH4>
                No added items. Use the form on the right to create one!
            </ContentH4>
        </ListItem>
    );
});
